import { KeyboardEvent } from 'react'

const TAB_STOPS = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]'

const tabStopsIn = (container: HTMLElement) =>
    Array.from(container.querySelectorAll<HTMLElement>(TAB_STOPS))
        .filter((element) => element.tabIndex >= 0 && !element.hasAttribute('data-headlessui-focus-guard'))

const keepTabWithin = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key !== 'Tab') {
        return
    }
    const stops = tabStopsIn(event.currentTarget)
    if (stops.length === 0) {
        return
    }
    const first = stops[0]
    const last = stops[stops.length - 1]
    const wrapTo = event.shiftKey
        ? document.activeElement === first && last
        : document.activeElement === last && first
    if (wrapTo) {
        event.preventDefault()
        wrapTo.focus()
    }
}

export default keepTabWithin
